export const IconMap = { '1xx': 'info', '2xx': 'check', '3xx': 'redo', '4xx': 'computer', '5xx': 'server' };
export const ColorMap = { '1xx': 'blue', '2xx': 'green', '3xx': 'brown', '4xx': 'orange', '5xx': 'red' };
